import { render, staticRenderFns } from "./UserListPickerModal.vue?vue&type=template&id=389155b7"
import script from "./UserListPickerModal.vue?vue&type=script&lang=ts"
export * from "./UserListPickerModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports